module.exports = __webpack_public_path__ + "static/media/Group 1276.d0362c41.svg";